module.exports = __webpack_public_path__ + "img/human-stencil.453190c8.png";